import Vue from 'vue';
import Vuex from 'vuex';
import auth from './auth';
import company from './company';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        auth,
        company,
    },
});
